import api from './api';
import axios from 'axios';
import type { SignedUploadResponse, FilePersistRequest } from '../types';

class StorageService {
    /**
     * Step 1: Get a signed upload URL from the backend
     */
    async getSignedUploadUrl(file: File): Promise<SignedUploadResponse> {
        const response = await api.post<SignedUploadResponse>('/storage/signed-upload', {
            file_name: file.name,
            mime_type: file.type,
            file_size: file.size
        });
        return response.data;
    }

    /**
     * Step 2: Upload the file directly to GCS using the signed URL
     */
    async uploadFileToGCS(uploadUrl: string, file: File): Promise<void> {
        await axios.put(uploadUrl, file, {
            headers: {
                'Content-Type': file.type
            }
        });
    }

    /**
     * Step 3: Persist the file metadata in the backend
     */
    async persistFile(data: FilePersistRequest): Promise<any> {
        const response = await api.post('/storage/files', data);
        return response.data;
    }

    /**
     * Helper method to handle the full upload flow
     */
    async uploadFile(file: File, category: string = 'documents'): Promise<any> {
        // 1. Get signed URL
        const signedData = await this.getSignedUploadUrl(file);

        // 2. Upload to GCS
        await this.uploadFileToGCS(signedData.upload_url, file);

        // 3. Persist metadata
        const persistedFile = await this.persistFile({
            object_name: signedData.object_name,
            public_url: signedData.public_url,
            file_name: file.name,
            mime_type: file.type,
            file_size: file.size,
            category: category
        });

        return persistedFile;
    }
}

export default new StorageService();
